import {
  OVERDUE_STATUSES,
  OverdueStatus,
  WELLNESS_PLAN_STATUSES,
} from "../config/params";

export const getScratchPayOverdueSubtitle = (
  overdueStatus: OverdueStatus,
): string => {
  if (overdueStatus === OVERDUE_STATUSES.OVERDUE) {
    return "Your ScratchPay payment could not be paid. " +
      "Please login to your ScratchPay account " +
      "to bring your account to good standing.";
  }
  return "Login to your ScratchPay account to pay your " +
    "overdue invoices. Once paid your benefits " +
    "will be restored.";
};

export const getPetOverdueStatus = (
  planStatus: string,
  isScratchpay?: boolean,
  isOverdue?: boolean,
): OverdueStatus | null => {
  const normalizedStatus = planStatus?.toLowerCase();
  if (isScratchpay && normalizedStatus === WELLNESS_PLAN_STATUSES.LOCKED) {
    return OVERDUE_STATUSES.PAUSED;
  }
  if (isScratchpay && isOverdue) return OVERDUE_STATUSES.OVERDUE;

  switch (normalizedStatus) {
  case WELLNESS_PLAN_STATUSES.PAUSED:
  case WELLNESS_PLAN_STATUSES.LOCKED:
    return OVERDUE_STATUSES.PAUSED;
  case WELLNESS_PLAN_STATUSES.CANCELLED:
    return OVERDUE_STATUSES.CANCELLED;
  default:
    return null;
  }
};

